import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "12",
      r: "1",
      transform: "rotate(90 16 12)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "1",
      transform: "rotate(90 12 12)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8",
      cy: "12",
      r: "1",
      transform: "rotate(90 8 12)"
    }, null, -1)
  ]))]))
}
export default { render: render }